import { render, staticRenderFns } from "./home-blocks.vue?vue&type=template&id=61927840&scoped=true&"
import script from "./home-blocks.vue?vue&type=script&lang=js&"
export * from "./home-blocks.vue?vue&type=script&lang=js&"
import style0 from "./home-blocks.vue?vue&type=style&index=0&id=61927840&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61927840",
  null
  
)

export default component.exports